const URL = "/sda-hoarding/sda-new/test-slot";

export async function isUrlBlocked(fetchFunc: typeof fetch): Promise<boolean> {
  try {
    const response = await fetchFunc(URL);
    return !(response.status >= 200 && response.status < 400);
  } catch (error) {
    return true;
  }
}
